import moment from "moment";
class detail {
    constructor(
        liId,
        legajo,
        empId,
        ent,
        sal,
        concepto,
        conceptoId,
        csCostoId,
        observaciones,
        stFormato,
        msgFormato,
        stProcesamiento,
        msgProcesamiento) {
        this.liId = liId;
        this.legajo = legajo;
        this.empId = empId;
        this.ent = moment(ent).format('YYYY-MM-DD HH:mm');
        this.sal = moment(sal).format('YYYY-MM-DD HH:mm');
        this.concepto = concepto;
        this.conceptoId = conceptoId;
        this.csCostoId = csCostoId;
        this.observaciones = observaciones;
        this.stFormato = stFormato;
        this.stFormatoIcon = this.getFormatoIcon(stFormato);
        this.msgFormato = msgFormato;
        this.stProcesamiento = stProcesamiento;
        this.msgProcesamiento = msgProcesamiento;
    }

    getFormatoIcon() {
        return this.stFormato ? "✔️" : "❌";
    }

    static fromJson({
        liId,
        legajo,
        empId,
        ent,
        sal,
        concepto,
        conceptoId,
        csCostoId,
        observaciones,
        stFormato,
        msgFormato,
        stProcesamiento,
        msgProcesamiento
    }) {
        return new detail(
            liId,
            legajo,
            empId,
            ent,
            sal,
            concepto,
            conceptoId,
            csCostoId,
            observaciones,
            stFormato,
            msgFormato,
            stProcesamiento,
            msgProcesamiento
        );
    }

    
}

export default detail;
